import { Button } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Loader from '../../../../../components/Loader';
import { useCreateTriggerFromBlockMutation } from '../../../../../generated/graphqlModels';
import withFlag from '../../../../../helpers/withFlag';
import { useRefreshChat } from '../../../../ai/Chat';
import { PluginProps } from '../Plugin';
import Text from './Text';

const TriggerBlock = (props: PluginProps) => {
  const { content } = props;
  const { t } = useTranslation();
  // console.log(content.data);

  const { refresh } = useRefreshChat();
  const [createTrigger, { loading, data }] =
    useCreateTriggerFromBlockMutation();
  const displayText = content?.data?.display_text;

  if (content.data.auto || (content.data.is_triggered && !displayText)) {
    return null;
  }

  const askForHelp = async () => {
    await createTrigger({
      variables: {
        id: content.data.id,
      },
    });
    refresh();
  };

  if (loading) {
    return <Loader />;
  }

  if (
    (content.data?.is_triggered || data?.createTriggerFromBlock) &&
    displayText
  ) {
    return (
      <Text
        {...props}
        content={{
          ...content,
          data: displayText,
        }}
      />
    );
  }

  if (data?.createTriggerFromBlock) {
    return null;
  }

  return (
    <Button colorScheme="blue" variant="ghost" onClick={askForHelp}>
      {content?.data?.display_text || t('plugin.triggerBlock.askForHelp')}
    </Button>
  );
};

export default withFlag(TriggerBlock, 'new-ai-feature');
